<template>
  <v-app class="app-default" :class="{'app-transparent':transparent, 'hide-nav': hideNav}">
    <v-toolbar height="40" class="header" dark fixed>
      <v-layout fill-height align-center :class="{'layout-wrap':!breakpoint.xs}">
        <v-toolbar-side-icon @click.stop="drawer=!drawer" class="bar-icon hidden-md-and-up"></v-toolbar-side-icon>
        <img src="/images/company-logo.png" width="43" height="12" style="margin-right: 12px;">
        |
        <v-toolbar-title class="caption">企业员工保险服务专家</v-toolbar-title>
        <v-spacer></v-spacer>
        <span
          class="caption caption-color hidden-sm-and-down"
          style="margin-right: 15px;"
        >客服与投诉电话：4006-234-345</span>
        <template v-if="!isLogin">
          <span
            class="caption"
            style="margin-right: 15px; color: #fff; text-decoration: none; cursor: pointer;"
            @click="goLogin"
          >登录</span>
          <router-link
            to="/register"
            class="caption"
            style="margin-right: 15px; color: #fff; text-decoration: none;"
          >注册</router-link>
        </template>
        <span
          v-else
          class="caption user-info-dropdown"
          style="margin-right: 15px; color: #fff;"
          @click.stop="toggleLogout"
        >
          {{ displayName }}
          <i class="dropdown-caret"></i>
          <div v-show="showLogout" class="logout-menu" @click.stop>
            <span class="logout-item" @click.stop="logout">退出登录</span>
          </div>
        </span>

      </v-layout>
    </v-toolbar>

    <AppNav v-model="drawer" v-if="!hideNav"></AppNav>

    <v-content class="content">
      <router-view></router-view>
    </v-content>

    <AppFooter/>
    <CLogin></CLogin>
  </v-app>
</template>

<script>
import AppFooter from "./components/AppFooter";
import AppNav from "./components/AppNav";

export default {
  name: "default",
  components: {
    AppFooter,
    AppNav,
  },
  data() {
    return {
      drawer: false,
      showLogout: false
    };
  },
  mounted() {
    document.addEventListener("click", this.closeLogout);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeLogout);
  },
  computed: {
    transparent() {
      return this.$route.meta.navTransparent || false;
    },
    hideNav() {
      return this.$route.meta.hideNav || false;
    },
    isLogin() {
      const appLogin = localStorage.getItem("app_login");
      return appLogin && appLogin === "1";
    },
    displayName() {
      const userInfoStr = localStorage.getItem("userInfo");
      if (!userInfoStr) return "";
      try {
        const user = JSON.parse(userInfoStr);
        return user.cusName || "";
      } catch (e) {
        return "";
      }
    },
    user() {
      return this.$store.state.user.userInfo;
    },
    userName() {
      if (this.user) {
        return (
          this.user.realName ||
          this.user.userAccount.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
        );
      }
      return "未知";
    }
  },
  methods: {
    goLogin() {
      const redirect = this.$route.fullPath;
      // 避免跳转到登录页自身
      if (redirect === "/login" || redirect.indexOf("/login?") === 0) {
        this.$router.push("/login");
      } else {
        this.$router.push({ path: "/login", query: { redirect } });
      }
    },
    toggleLogout() {
      this.showLogout = !this.showLogout;
    },
    closeLogout() {
      this.showLogout = false;
    },
    logout() {
      this.showLogout = false;
      this.$store.dispatch("logout").then(() => {
        // this.$router.replace({ name: "home" });
        this.$router.go(0)
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$toolbar-height: 40px;
$nav-height: 80px;
img.nav-logo-img{
  width: 25px;
}
.app-default {
  .header {
    overflow: visible;
    z-index: 1001;
    .v-toolbar__content {
      padding: 0;
      overflow: visible;
    }
  }
  .content {
    margin-top: $toolbar-height + $nav-height;
  }
}
.app-transparent {
  .content {
    margin-top: $toolbar-height;
  }
  .header {
    overflow: visible;
    .v-toolbar__content {
      overflow: visible;
    }
  }
}
.hide-nav {
  .content {
    margin-top: $toolbar-height;
  }
  .header {
    overflow: visible;
    .v-toolbar__content {
      overflow: visible;
    }
  }
}
.v-toolbar__title:not(:first-child) {
  margin-left: 12px;
}

.user-info-dropdown {
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;

  .dropdown-caret {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 4px;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #fff;
    transition: transform 0.15s;
  }

  .logout-menu {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 8px;
    min-width: 96px;
    padding: 4px 0;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 1000;

    .logout-item {
      display: block;
      padding: 8px 16px;
      white-space: nowrap;
      color: #333;
      font-size: 13px;
      cursor: pointer;

      &:hover {
        background: #f5f5f5;
        color: #dd122a;
      }
    }
  }
}
</style>
